import { useMemo, useRef } from 'react';

// Данные таблицы запрашиваются при каждом изменении лимита/страницы/фильтра, ответы могут приходить не по порядку.
// Применять к состоянию нужно только ответ самого последнего запроса.
export const useLatestRequest = () => {
    const counter = useRef(0);
    return useMemo(() => ({
        begin: () => ++counter.current,
        isLatest: (id: number) => id === counter.current,
    }), []);
};
